
const errorCode = {
  '-8940004': '用户token过期,请重新登录',
  '-8940002': ''
}

//我不会跳过枚举值
const jumpListReason = [
  { codeType: 7, test: '题目太难' },
  { codeType: 2, test: '没学会这个知识点' },
  { codeType: 1, test: '题目描述的不清楚不好理解' },
  {codeType: 9, test: '其他原因', isOtherReason: true}
]


//换题的枚举值
const changeTopicReason = [
  { codeType: 56, test: '题目太难' },
  { codeType: 51, test: '没学会这个知识点' },
  { codeType: 50, test: '题目描述的不清楚不好理解' },
  {codeType: 9, test: '其他原因', isOtherReason: true}
]

export {
  errorCode,
  jumpListReason,
  changeTopicReason,
}



// WEBPACK FOOTER //
// ./src/config/index.js